import React, { Ref, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";

interface props {
	label?: string;
	value?: string;
	handleSearchValueChange: (inputValue: string) => void;
	handleClear?: () => void;
	inputRef?: Ref<HTMLInputElement>;
}

export const SearchInput = React.memo(
	({ label, value, handleSearchValueChange, handleClear, inputRef }: props) => {
		const [inputValue, setInputValue] = useState(value ?? "");

		useEffect(() => {
			setInputValue(value ?? "");
		}, [value]);

		useEffect(() => {
			const timer = setTimeout(() => {
				handleSearchValueChange(inputValue);
			}, 500);

			return () => {
				clearTimeout(timer);
			};
		}, [inputValue, handleSearchValueChange]);

		const clearValue = () => {
			setInputValue("");
			if (handleClear) {
				handleClear();
			}
		};

		return (
			<div className="flex w-100">
				<TextField
					inputRef={inputRef}
					id={`search-${label}`}
					label={label}
					type="text"
					fullWidth
					value={inputValue}
					onChange={(e) => setInputValue(e.target.value)}
				/>
				<img
					src="images/svg/close-black.svg"
					alt="clear"
					onClick={clearValue}
					width="12"
					height="12"
					className="mt-4 ml-4"
				/>
			</div>
		);
	}
);
